import { useEffect } from 'react';
import { connect } from 'react-redux';
import PageContainer from '../common/PageContainer';
import * as selectors from '../../redux/selectors';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { Breadcrumb, Button, Card, Checkbox, Form, Icon, Image, Menu, Pagination, Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import './photo.scss';
import { SelectField, TextField } from '../common/FormFields';
import { Formik } from 'formik';
import { dateOptions } from './photos.constants';

const PhotosPage = ({ count, page, photos, query, setPhotoQuery, searchPhotos, getUsers, users, setPhotoPage }) => {
  useEffect(() => {
    searchPhotos(query);
    getUsers();
  }, []);

  const handlePageChange = (activePage, formik) => {
    setPhotoPage(activePage);
    searchPhotos(formik.values);
  };

  const handleSubmit = currentQuery => {
    searchPhotos(currentQuery);
    setPhotoQuery(currentQuery);
  };

  const getUrl = (photo, scale) => {
    const cloudinary = 'https://res.cloudinary.com/culturemap-com/';
    const s3 = 'https://culturemedia.s3.amazonaws.com/';

    if (photo?.src && !photo?.original) {
      return s3 + photo?.src;
    }

    let url = photo?.original;
    if (!url || !url?.includes('image/upload/') || !scale) return cloudinary + url;
    return cloudinary + url?.replace('upload', 'upload/w_100');
  };

  return (
    <PageContainer>
      <Formik initialValues={query} enableReinitialize onSubmit={handleSubmit}>
        {formik => (
          <>
            <Breadcrumb>
              <Breadcrumb.Section>Photos</Breadcrumb.Section>
              <Breadcrumb.Divider icon="right angle" />
              <Breadcrumb.Section>Search</Breadcrumb.Section>
            </Breadcrumb>

            <Menu borderless>
              <Menu.Item header>
                <Icon name="picture" />
                Photo Search
              </Menu.Item>

              <Menu.Menu position="right">
                <Menu.Item>
                  <Button content="Add photo" icon="plus" positive as="a" href="/photos/add" />
                </Menu.Item>
              </Menu.Menu>
            </Menu>

            <div>
              <div className="photo-search-main">
                <div>
                  <Table size="small" compact="very" celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>
                          <Checkbox />
                        </Table.HeaderCell>
                        <Table.HeaderCell width="4">Alt tag</Table.HeaderCell>
                        <Table.HeaderCell>Thumbnail</Table.HeaderCell>
                        <Table.HeaderCell>Tags</Table.HeaderCell>
                        <Table.HeaderCell>Credit</Table.HeaderCell>
                        <Table.HeaderCell>Upload datetime</Table.HeaderCell>
                        <Table.HeaderCell>Added by</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {photos?.map((photo, idx) => (
                        <Table.Row key={idx}>
                          <Table.Cell>
                            <Checkbox />
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={'/photos/' + photo.id}>{photo?.altTag}</Link>
                          </Table.Cell>
                          <Table.Cell>
                            <a rel="noreferrer" href={`${getUrl(photo)}`} target="_blank">
                              <Image src={`${getUrl(photo, true)}`} size="tiny" />
                            </a>
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={'/photos/' + photo.id}>{photo?.tags}</Link>
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={'/photos/' + photo.id}>{photo?.credit}</Link>
                          </Table.Cell>
                          <Table.Cell>{moment(photo?.uploadDatetime).format('LLL')}</Table.Cell>
                          <Table.Cell>
                            {photo?.addedBy?.firstName} {photo?.addedBy?.lastName}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>

                <div style={{ display: 'grid', alignItems: 'start', alignContent: 'start' }}>
                  <Card className="photo-search-sidebar">
                    <Card.Content className="photo-search-sidebar-header">
                      <Card.Header content="Filter" style={{ fontSize: 14 }} />
                    </Card.Content>
                    <Card.Content>
                      <Form>
                        <Form.Field>
                          <label>Alt tag</label>
                          <TextField
                            name="altTag"
                            id="altTag"
                            formik={formik}
                            onChange={formik.handleChange}
                            value={formik.values.altTag}
                          />
                        </Form.Field>

                        <Form.Field>
                          <label>Upload datetime</label>
                          <SelectField
                            name="uploadDatetime"
                            id="uploadDatetime"
                            options={dateOptions}
                            formik={formik}
                            onChange={formik.handleChange}
                            value={formik.values.uploadDatetime}
                          />
                        </Form.Field>

                        <Form.Field>
                          <label>Added by</label>
                          <SelectField
                            name="addedById"
                            id="addedById"
                            value={formik.values.addedById}
                            options={users}
                            formik={formik}
                          />
                        </Form.Field>

                        <br />

                        <Button
                          type="submit"
                          onClick={formik.submitForm}
                          size="tiny"
                          content="Search"
                          default
                          fluid
                          positive
                        />
                        <br />

                        <Button
                          size="tiny"
                          onClick={() => {
                            formik.resetForm();
                            setPhotoQuery({
                              uploadDatetime: 'Any',
                              altTag: '',
                              missingCredits: 'All',
                              onlyPhoto: 'All',
                              addedById: '',
                            });
                            searchPhotos();
                            setPhotoPage(1);
                          }}
                          content="Reset"
                          default
                          fluid
                        />
                      </Form>
                    </Card.Content>
                  </Card>

                  <br />

                  <div className="photo-search-pagination-container">
                    <Pagination
                      className="pagination"
                      boundaryRange={0}
                      ellipsisItem={null}
                      firstItem={undefined}
                      size="mini"
                      lastItem={undefined}
                      siblingRange={1}
                      activePage={page}
                      totalPages={Math.ceil(count / 50)}
                      onPageChange={(e, { activePage }) => handlePageChange(activePage, formik)}
                    />
                  </div>
                  <div className="photo-count">50 of {count} results</div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  current: selectors.photos.current(state),
  count: selectors.photos.count(state),
  page: selectors.photos.page(state),
  photos: selectors.photos.photos(state),
  users: selectors.photos.userOptions(state),
  query: selectors.photos.query(state),
});

const mapDispatchToProps = dispatch => ({
  getPhotos: bindActionCreators(actions.photos.getPhotos, dispatch),
  getPhotoById: bindActionCreators(actions.photos.getPhotoById, dispatch),
  searchPhotos: bindActionCreators(actions.photos.searchPhotos, dispatch),
  getUsers: bindActionCreators(actions.photos.getUsers, dispatch),
  setPhotoPage: bindActionCreators(actions.photos.setPhotoPage, dispatch),
  setPhotoQuery: bindActionCreators(actions.photos.setPhotoQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhotosPage);
